import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap cursor-pointer">
              亚欧风格志
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              探索亚洲与欧美跨文化融合的无限可能，从时尚穿搭、美妆潮流到生活方式，发现属于你的跨文化风格密码。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="/category/fashion" className="hover:text-background-100 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="/about" className="hover:text-background-100 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer" aria-label="小红书" rel="nofollow">
                <i className="ri-red-packet-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer" aria-label="Instagram" rel="nofollow">
                <i className="ri-instagram-line text-background-200"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 亚欧风格志 —— 探索跨文化融合之美
          </p>
          <p className="text-xs text-background-400">
            亚洲欧美风格融合指南 · 跨文化时尚与生活方式全解析
          </p>
        </div>
      </div>
    </footer>
  );
}